import { Injectable } from "@angular/core";
import {
    CanLoad,
    Router,
    UrlTree,
} from "@angular/router";
import { ResponseModel } from "@Front-end/seed/models/shared";
import { User } from "@Front-end/seed/models/user";
import {
    UserFacade,
    UserRestService,
} from "@Front-end/seed/modules/user";
import { LocalizeRouterService } from "@gilsdav/ngx-translate-router";
import {
    defer,
    exhaustMap,
    map,
    Observable,
    of,
} from "rxjs";

@Injectable({
    // eslint-disable-next-line no-restricted-syntax
    providedIn: "root",
})
export class AuthUserGuard implements CanLoad {

    constructor(private userFacade: UserFacade,
                private userRestService: UserRestService,
                private router: Router,
                private localizeRouterService: LocalizeRouterService) {
    }

    public canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.userFacade.getUser().pipe(
            exhaustMap((storeUser: User | null) =>
                defer(() => storeUser
                    ? of(storeUser)
                    : this.userRestService.getUser().pipe(
                        map(
                            (response: ResponseModel<User>) => response.result ? response.result : null,
                        ),
                    ),
                ).pipe(
                    map((user: User | null) => {
                        const a = this.localizeRouterService.translateRoute("/");
                        if (typeof a === "string" && !user) {
                            return this.router.parseUrl(a);
                        }
                        return true;
                    }),
                ),
            ),
        );
    }
}
